module.exports = __webpack_public_path__ + "resources/img/img_gridgain_apache1_m.b50c59784da1e9036093686f8cc3be0a.png";